import {
    WORKSHOP_QUESTS_FETCHING,
    WORKSHOP_QUESTS_SUCCESS,
    WORKSHOP_QUESTS_HAS_MORE
} from '../types'

const defaultState = {
    workshopQuests: {
        list: [],
        fetch: false,
        hasMore: true
    }
}

export default (state = defaultState, action) => {
    switch (action.type) {
        case WORKSHOP_QUESTS_FETCHING:
            return {
                ...state,
                workshopQuests: {
                    ...state.workshopQuests,
                    fetch: action.payload
                }
            }
        case WORKSHOP_QUESTS_SUCCESS:
            return {
                ...state,
                workshopQuests: {
                    ...state.workshopQuests,
                    list: action.payload
                }
            }
        case WORKSHOP_QUESTS_HAS_MORE:
            return {
                ...state,
                workshopQuests: {
                    ...state.workshopQuests,
                    hasMore: action.payload
                }
            }
        default:
            return state
    }
}
